import { CONSULTANT_CARE_MSG, USER_CARE_MSG } from './const'

export default {
    data() {
        return {
            care_type: '',
            care_msg: ''
        }
    },
    methods: {
        initCareMsg() {
            let type
            const num = Math.round(Math.random())
            const h = new Date().getHours()
            if (h < 6) {
                type = 'midnight'
            } else if (h < 12) {
                type = 'morning'
            } else if (h < 19) {
                type = 'afternoon'
            } else {
                type = 'evening'
            }
            this.care_type = type === 'morning' || type === 'afternoon'
                ? 'daytime'
                : 'night'
            this.care_msg = this.user.is_consultant
                ? CONSULTANT_CARE_MSG[type][num]
                : USER_CARE_MSG[type][num]
        }
    }
}
